[
  {
    "code": "MU-AG",
    "name": "Agalega Islands"
  },
  {
    "code": "MU-BR",
    "name": "Beau Bassin-Rose Hill"
  },
  {
    "code": "MU-BL",
    "name": "Black River"
  },
  {
    "code": "MU-CC",
    "name": "Cargados Carajos Shoals"
  },
  {
    "code": "MU-CU",
    "name": "Curepipe"
  },
  {
    "code": "MU-FL",
    "name": "Flacq"
  },
  {
    "code": "MU-GP",
    "name": "Grand Port"
  },
  {
    "code": "MU-MO",
    "name": "Moka"
  },
  {
    "code": "MU-PA",
    "name": "Pamplemousses"
  },
  {
    "code": "MU-PW",
    "name": "Plaines Wilhems"
  },
  {
    "code": "MU-PL",
    "name": "Port Louis"
  },
  {
    "code": "MU-PU",
    "name": "Port Louis City"
  },
  {
    "code": "MU-QB",
    "name": "Quatre Bornes"
  },
  {
    "code": "MU-RR",
    "name": "Rivière du Rempart"
  },
  {
    "code": "MU-RO",
    "name": "Rodrigues Island"
  },
  {
    "code": "MU-SA",
    "name": "Savanne"
  },
  {
    "code": "MU-VP",
    "name": "Vacoas-Phoenix"
  }
]